import { call, put, takeEvery, all, fork } from "redux-saga/effects";
import { toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

import {
  GET_DEPRECIATION,
  DELETE_DEPRECIATION,
  UPDATE_DEPRECIATION,
  ADD_NEW_DEPRECIATION,
} from "./actionType";

import {
  getDepreciationSuccess,
  getDepreciationFail,
  deleteDepreciationSuccess,
  deleteDepreciationFail,
  updateDepreciationSuccess,
  updateDepreciationFail,
  addDepreciationSuccess,
  addDepreciationFail,
} from "./action";

//Include Both Helper File with needed methods
import {
  approveDepreciationApi,
  getDepreciationApi,
  updateDepreciationApi,
  deleteDepreciationApi,
  addNewDepreciationApi
} from "../../helpers/backend_helper";

function* getDepreciation({ payload: depreciation }) {
  try {
    const response = yield call(getDepreciationApi, depreciation);
    yield put(getDepreciationSuccess(GET_DEPRECIATION, response.data));
  } catch (error) {
    yield put(getDepreciationFail(GET_DEPRECIATION, error));
  }
}

function* onUpdateDepreciation({ payload: depreciation }) {
  try {
    if (depreciation.setApprove) {
      const response = yield call(approveDepreciationApi, depreciation);
      yield put(updateDepreciationSuccess(response));
      toast.success(response.message, { position: "bottom-left", autoClose: 3000 });
    }
    else {
      const response = yield call(updateDepreciationApi, depreciation);
      yield put(updateDepreciationSuccess(response));
      toast.success(response.message, { position: "bottom-left", autoClose: 3000 });
    }
  } catch (error) {
    yield put(updateDepreciationFail(error));
    toast.error(error.response.data.message, { position: "bottom-left", autoClose: 3000 });
  }
}

function* onDeleteDepreciation({ payload: depreciation }) {
  try {
    const response = yield call(deleteDepreciationApi, depreciation);
    yield put(deleteDepreciationSuccess({ depreciation, ...response }));
    toast.success(response.message, { position: "bottom-left", autoClose: 3000 });
  } catch (error) {
    yield put(deleteDepreciationFail(error));
    toast.error(error.response.data.message, { position: "bottom-left", autoClose: 3000 });
  }
}

function* onAddNewDepreciation({ payload: depreciation }) {
  try {
    const response = yield call(addNewDepreciationApi, depreciation);
    yield put(addDepreciationSuccess(response));
    toast.success(response.message, { position: "bottom-left", autoClose: 3000 });
  } catch (error) {
    yield put(addDepreciationFail(error));
    toast.error(error.response.data.message, { position: "bottom-left", autoClose: 3000 });
  }

}

export function* watchGetDepreciation() {
  yield takeEvery(GET_DEPRECIATION, getDepreciation);
}

export function* watchUpdateDepreciation() {
  yield takeEvery(UPDATE_DEPRECIATION, onUpdateDepreciation);
}

export function* watchDeleteDepreciation() {
  yield takeEvery(DELETE_DEPRECIATION, onDeleteDepreciation);
}

export function* watchAddNewDepreciation() {
  yield takeEvery(ADD_NEW_DEPRECIATION, onAddNewDepreciation);
}

function* depreciationSaga() {
  yield all([
    fork(watchGetDepreciation),
    fork(watchDeleteDepreciation),
    fork(watchUpdateDepreciation),
    fork(watchAddNewDepreciation),
  ]);
}

export default depreciationSaga;
